import React, { useEffect } from 'react';

import { Space } from 'antd';
import { useTranslation } from 'react-i18next';

import useForm from '../../../hooks/useForm';

import PageTitle from '../../PageTitle';
import FormWrapper from '../../FormWrapper';
import SaveButton from '../../buttons/SaveButton';
import CancelButton from '../../buttons/CancelButton';
import usePermissions from '../../../hooks/usePermission';

const permissionsMap = {
  canEdit: ['SYS_SUPERUSER', 'TAXONOMIES_PERMISSION'],
};

const EditTransportBrandForm = ({ brand, onSubmit, onCancel }) => {
  const { t } = useTranslation();
  const { handleSubmit, value, input, setFormValue } = useForm({
    initialValue: brand,
    onSubmit,
    onCancel,
  });
  const { canEdit } = usePermissions(permissionsMap);

  useEffect(() => {
    setFormValue(brand);
  }, [setFormValue, brand]);

  return (
    <>
      <form onSubmit={handleSubmit}>
        <PageTitle
          title={brand.name || t('entity.taxonomy.transportBrand._singular')}
        />
        <FormWrapper>
          <FormWrapper.Single>
            <FormWrapper.Input
              label={t('entity.taxonomy.transportBrand.name')}
              props={{
                ...input('name'),
                disabled: value.deleted || !canEdit,
              }}
            />
          </FormWrapper.Single>
        </FormWrapper>
        <Space style={{ paddingTop: '1rem' }}>
          {canEdit && <SaveButton disabled={value.deleted} />}
          <CancelButton onCancel={onCancel} />
        </Space>
      </form>
    </>
  );
};
export default EditTransportBrandForm;
